export default angular.module("mars.vet.dnareports.controller.ancestry", []).controller('AncestryTreeController',
    function($rootScope, $scope, $window, BreedListService, EntryService, EntryIDService, ImageService, NavigationService, ChartService, BreedClusterService, TranslationService, reportdata) {
        'ngInject'
        let resultString = reportdata.resultString;
        let sampleDetails = reportdata.sampleDetails;

        var reportType = 'online';
        $scope.onloadFun = function() {
            reportType = 'pdf';
        }
        EntryService.getEntry(EntryIDService.getEntryID('Ancestry Tree')).then(function(response) {

            NavigationService.setNavigationUrls();

            var fields = response.fields;
            $scope.description = fields.description;

            $rootScope.pageTitle = fields.title;
            $scope.subtitle = fields.subtitle;
            $scope.messagebanner = fields.messageBanner;
            $scope.msgbannerArr = [];
            $scope.msgbannerArr = $scope.messagebanner.split("&");

            $scope.traceConfidenceText = fields.traceConfidence;

            $scope.traceConfidence = BreedListService.getTraceConfidence();

            $scope.descriptionArray = [];

            angular.forEach($scope.description.split("\n"), function(value, key) {
                if (value != '') {
                    $scope.descriptionArray.push(value);
                }
            });

            $scope.imgPath = "/staticresources/dnareports/images/" + resultString.sampleID + "/ancestrychart.png";
            $scope.imgLinks = "/staticresources/dnareports/images/" + resultString.sampleID + "/ancestrychart_links.png";

            $window.ga('send', 'pageview', {
                'page': $rootScope.pageTitle
            });
            $scope.title = fields.title;


            var canvasObject = document.getElementById('imagemap');
            var ancestryChartObject = document.getElementById('ancestryChart');
            var toolTipObject = document.getElementById('toolTipBox');
            var canvas = document.getElementById('imagemap').getContext('2d');
            var lastSelected = "Nothing";
            var jsonForAncestryChart = reportdata.ancestryChartJSON;

            // create an image object and get it�s source
            var img = new Image();
            img.src = "/staticresources/dnareports/images/" + resultString.sampleID + "/ancestrychart_links.png";

            $(img).on('load',function(){
            		
            	
           // $(img).load(function() {
                canvasObject.width = img.width;
                canvasObject.height = img.height;
                canvas.drawImage(img, 0, 0);
            });

            // http://www.javascripter.net/faq/rgbtohex.htm
            function rgbToHex(R, G, B) {
                return toHex(R) + toHex(G) + toHex(B)
            }

            function toHex(n) {
                n = parseInt(n, 10);
                if (isNaN(n)) {
                    return "00";
                }
                n = Math.max(0, Math.min(n, 255));
                return "0123456789ABCDEF".charAt((n - n % 16) / 16) + "0123456789ABCDEF".charAt(n % 16);
            }

            function loadJSONAncestryChart(jsonAncestryChartFile) {
                $.getJSON(jsonAncestryChartFile, function(response) {
                    jsonForAncestryChart = response.data.fields.file.url;
                });
            }

            function selectCurrentBreed(event) {

                var currentArray = findCellObjectFromRGB(event);

                if (currentArray === "Nothing") {
                    lastSelected = "Nothing";
                    $('#result input').val(lastSelected);

                } else {
                    var combinationText = "";

                    for (var breed = 0; breed < currentArray.length; breed++) {
                        var breedString = currentArray[breed].breed;
                        combinationText += breedString;
                        if (breed < currentArray.length - 1) {
                            combinationText += ", ";
                        }
                    }

                    lastSelected = currentArray;

                    $('#result input').val(combinationText);

                }

            }

            function clickCurrentBreed(event) {

                if (lastSelected === "Nothing") {
                    clearBox();
                } else if (lastSelected.length == 1) {
                    linkToBreeds(lastSelected[0].breed);
                } else {

                    var x = event.pageX;
                    var y = event.pageY;

                    toolTipObject.width = 1 + "px";
                    toolTipObject.height = 1 + "px";
                    toolTipObject.style.display = "block";
                    var linkTextInToolTip = "";

                    for (var i = 0; i < lastSelected.length; i++) {
                        var breed = lastSelected[i].breed;
                        if (breed == "Mixed Breed") {
                            linkTextInToolTip += "<a href=#/mixedbreedgroups/" + EntryIDService.getEntryID("Mixed Breed Groups") + ">" + breed + "</a><br/>";
                        } else {
                            linkTextInToolTip += "<a href=#/breed/" + EntryIDService.getEntryID(breed) + ">" + breed + "</a><br/>";
                        }
                    }
                    toolTipObject.innerHTML = linkTextInToolTip;

                    var x = event.pageX;
                    var y = event.pageY;

                    toolTipObject.style.left = x + "px";
                    toolTipObject.style.top = y + "px";
                }
            }

            function findCellObjectFromRGB(event) {
                // getting user coordinates
                var x = event.pageX - ancestryChartObject.offsetLeft;
                var y = event.pageY - ancestryChartObject.offsetTop;

                var xProp = x / ancestryChartObject.width;
                var yProp = y / ancestryChartObject.height;


                // getting image data and RGB values
                var img_data = canvas.getImageData(xProp * img.width, yProp * img.height, 1, 1).data;

                var R = img_data[0];
                var G = img_data[1];
                var B = img_data[2];

                var rgb = R + ',' + G + ',' + B;

                // convert RGB to HEX
                var hex = rgbToHex(R, G, B);
                // making the color the value of the input
                $('#rgb input').val(rgb);
                $('#hex input').val('#' + hex);

                var returnValue = "";

                if (hex in jsonForAncestryChart) {
                    returnValue = jsonForAncestryChart[hex];
                } else {
                    returnValue = "Nothing";
                }

                return returnValue;

            }

            function changeMouse() {
                var currentArray = findCellObjectFromRGB(event);

                if (currentArray === "Nothing") {
                    ancestryChartObject.style.cursor = "auto";
                } else {
                    ancestryChartObject.style.cursor = "pointer";
                }

            }

            function linkToBreeds(breed) {
                if (breed == "Mixed Breed") {
                    window.location = "#/mixedbreedgroups/" + EntryIDService.getEntryID("Mixed Breed Groups");
                } else {
                    window.location = "#/breed/" + EntryIDService.getEntryID(breed);
                }
                clearBox();
                $('#final input').val(breed);
            }

            function clearBox() {
                toolTipObject.style.display = "none";
                ancestryChartObject.style.cursor = "auto";
            }

            $('#ancestryChart').click(function(event) {
                selectCurrentBreed(event);
                clickCurrentBreed(event);
            });

            $('#ancestryChart').mousemove(function(event) {
                changeMouse(event);
            });


            $scope.petName = sampleDetails.petDetails.petName;

        }, function(error) {
            // promise rejected, could log the error with:
            // console.log('error', error);
        });

    }).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/ancestry.controller.js